import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'
import moment from 'moment'
import 'swiper/swiper-bundle.min.css'
import http from 'src/helper/http'
import ReminderBtn from 'src/component/showTost'
import Message from 'src/component/Message'
@inject('store')
@observer
export default class extends Component {
  

  state = {
    codeValue:'',
    postsecList:[],
    recodList:[],
    lang:langM.en,
    language:'en',
    typeObj:{
      'invite_code':{
        'en':"Invited  Code",
        'ar':"كود الدعوة",
        'tr':"Davet Kodu",
        'zh':"Invited  Code",
      }
    },
    inCbCf:false,
    listRootHeight:10,
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, langM)

    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    this.setState({
      uid: uid
    })

    if (language == 'tr') {
      setDocumentTitle('Davet Kodu')
    } else if (language == 'en') {
      setDocumentTitle('Gift Code')
    } else if (language == 'ar') {
      setDocumentTitle('كود الهدية')
    }else {
      setDocumentTitle('Gift Code')
    }
   

  }

  componentDidMount(){
  }

  // 初始化/接口请求初始化

  render() {
    let { lang, language, recodList, typeObj, inCbCf, listRootHeight } = this.state
    return (
      <div  className={`giftcodeview ${language == 'ar'?'in-ar':''}` }>
         {/* <div className='close-web-view' style={{top:`${inCbCf?'0.88rem':0}`}}>
          <img className='close-img-icon' style={{ transform: `rotate(${language == 'ar' ? '180' : '0'}deg)` }} onClick={() => this.handleClose()} src='/img/app/ruby-agent/close-icon.png' />
          <div className='name-text'>{'Gift Received Record'}</div>
          <img className='close-img-icon' onClick={() => {}} src='/img/app/ruby-agent/recolde-detail.png' />
        </div>
        <div className='top-roots' style={{width:'7.5rem', height:'0.88rem', margin:'0 auto'}}></div>
        <div className='in-root'></div>
        <div className='list-root-giftcodeview' style={{height:`${listRootHeight}rem`}}>
          <div className='item-root'>
             <div className='time-tips'>2024-08-12</div>
            <div className='record-list'>
              <div className='inLeft'>
                 <div className='item-atv'></div>
                 <div className='item-info'>
                   <div className='name'></div>
                   <div className='id-num'>ID: 12345</div>
                 </div>
              </div>
              <div className='inRight'>
                <div className='gold-root'>
                  <img className='gold-icon'></img>
                  <div className='gold-num'></div>
                </div>
                <div className='times'></div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/giftcodeview/index.js